module.exports = __webpack_public_path__ + "img/logo.f45c7dce.png";